module.exports = "/img/kamba-logo.png?0eaa11e23167fd032da10dfd4f788796";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/identity/kamba-logo.png
// module id = BL3U
// module chunks = 80